import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
} from "reactstrap";
import { INDIAN_STATES } from "../../../Constants/Const";
import Select from "react-select";
import { Plus, X } from "react-feather";

const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  // mobileNo: Yup.string()
  //   .required("Mobile number is required")
  //   .matches(/^[0-9]{10}$/, "Must be a valid 10-digit number"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  state: Yup.string().required("State is required"),
  gstnNo: Yup.string()
    .required("GSTIN No is required")
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GSTIN format",
    ),
  // bankName: Yup.string().required("Bank name is required"),
  // branchName: Yup.string().required("Branch name is required"),
  // accountNo: Yup.string()
  //   .required("Account number is required")
  //   .matches(/^[0-9]+$/, "Account number must be numeric"),
  // ifscCode: Yup.string()
  //   .required("IFSC is required")
  //   .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC format"),
});

const EditCustomerForm = ({ customer, onSubmit }) => {
  if (!customer) return null;

  const initialValues = {
    name: customer.name || "",
    email: customer.email || "",
    mobileNo: customer.mobileNo || "",
    mobileSecNo: customer.mobileSecNo || "",
    state: customer.state || "",
    address: customer.address || "",
    faxNo: customer.faxNo || "",
    webSite: customer.webSite || "",
    cstTinNo: customer.cstTinNo || "",
    vatTinNo: customer.vatTinNo || "",
    tanNo: customer.tanNo || "",
    panNo: customer.panNo || "",
    serviceTaxNo: customer.serviceTaxNo || "",
    eccNo: customer.eccNo || "",
    gstnNo: customer.gstnNo || "",
    creditDays: customer.creditDays || 0,
    creditLimit: customer.creditLimit || 0,
    balance: customer.balance || 0,
    bankName: customer.bankName || "",
    branchName: customer.branchName || "",
    accountNo: customer.accountNo || "",
    ifscCode: customer.ifscCode || "",
    addressDtos: customer.addressDtos?.length
      ? customer.addressDtos
      : [{ address: "" }],
    contactPersonDtos: customer.contactPersonDtos?.length
      ? customer.contactPersonDtos
      : [{ name: "", email: "", mobileNo: "" }],
  };

  //   const handleSubmit = (values) => {
  //     const { id, ...restCustomer } = customer;

  //     const updatedCustomer = {
  //       ...restCustomer,
  //       ...values,
  //       mobileSecNo: Number(values.mobileSecNo || 0),
  //       creditDays: Number(values.creditDays || 0),
  //       creditLimit: Number(values.creditLimit || 0),
  //       balance: Number(values.balance || 0),
  //       accountNo: Number(values.accountNo || 0),
  //     };
  //     if (onSubmit) onSubmit(updatedCustomer);
  //   };

  const handleSubmit = (values) => {
    const { id, ...restCustomer } = customer;

    // Step 1: Merge values and convert numeric fields
    const mergedCustomer = {
      ...restCustomer,
      ...values,
      mobileSecNo: values.mobileSecNo ? Number(values.mobileSecNo) : undefined,
      creditDays: values.creditDays ? Number(values.creditDays) : undefined,
      creditLimit: values.creditLimit ? Number(values.creditLimit) : undefined,
      balance: values.balance ? Number(values.balance) : undefined,
      accountNo: values.accountNo ? Number(values.accountNo) : undefined,
    };

    const cleanObject = (obj) => {
      if (Array.isArray(obj)) {
        const cleanedArray = obj
          .map((item) => cleanObject(item))
          .filter((item) => Object.keys(item).length > 0);
        return cleanedArray.length > 0 ? cleanedArray : undefined;
      } else if (typeof obj === "object" && obj !== null) {
        const cleanedEntries = Object.entries(obj)
          .map(([key, value]) => [key, cleanObject(value)])
          .filter(([_, value]) => {
            if (Array.isArray(value)) return value && value.length > 0;
            return value !== "" && value !== null && value !== undefined;
          });
        return Object.fromEntries(cleanedEntries);
      }
      return obj;
    };

    const updatedCustomer = cleanObject(mergedCustomer);

    if (onSubmit) onSubmit(updatedCustomer);
  };

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, touched, errors }) => (
            <Form>
              {/* === General Information === */}
              <div className="mb-4">
                <h5 className="text-success mb-3">General Information</h5>
                <Row className="g-3">
                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        Name <span className="text-danger">*</span>
                      </Label>
                      <Field
                        name="name"
                        as={Input}
                        invalid={touched.name && !!errors.name}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Mobile No.</Label>
                      <Field
                        name="mobileNo"
                        as={Input}
                        invalid={touched.mobileNo && !!errors.mobileNo}
                      />
                      <ErrorMessage
                        name="mobileNo"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Alternate Mobile No.</Label>
                      <Field name="mobileSecNo" as={Input} />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        Address <span className="text-danger">*</span>
                      </Label>
                      <Field
                        name="address"
                        as={Input}
                        type=""
                        invalid={touched.address && !!errors.address}
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>
                        Email <span className="text-danger">*</span>
                      </Label>
                      <Field
                        name="email"
                        as={Input}
                        type="email"
                        invalid={touched.email && !!errors.email}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Fax No</Label>
                      <Field name="faxNo" as={Input} />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>
                        State <span className="text-danger">*</span>
                      </Label>
                      <Field name="state">
                        {({ form }) => (
                          <Select
                            options={INDIAN_STATES}
                            name="state"
                            placeholder="Select State"
                            value={
                              INDIAN_STATES.find(
                                (option) => option.value === form.values.state,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              form.setFieldValue(
                                "state",
                                selectedOption ? selectedOption.value : "",
                              )
                            }
                            onBlur={() => form.setFieldTouched("state", true)}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-danger small mt-1"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Website</Label>
                      <Field name="webSite" as={Input} />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* === Other Details === */}
              <div className="mb-4">
                <h5 className="text-success mb-3">Other Details</h5>
                <Row className="g-3">
                  <Col md={4}>
                    <h6 className="text-primary mb-2">Bank Info</h6>
                    <FormGroup>
                      <Label>Bank Name</Label>
                      <Field
                        name="bankName"
                        as={Input}
                        invalid={touched.bankName && !!errors.bankName}
                      />
                      <ErrorMessage
                        name="bankName"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Branch Name</Label>
                      <Field
                        name="branchName"
                        as={Input}
                        invalid={touched.branchName && !!errors.branchName}
                      />
                      <ErrorMessage
                        name="branchName"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Account No</Label>
                      <Field
                        name="accountNo"
                        as={Input}
                        invalid={touched.accountNo && !!errors.accountNo}
                      />
                      <ErrorMessage
                        name="accountNo"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>IFSC Code</Label>
                      <Field
                        name="ifscCode"
                        as={Input}
                        invalid={touched.ifscCode && !!errors.ifscCode}
                      />
                      <ErrorMessage
                        name="ifscCode"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <h6 className="text-primary mb-2">Tax & Legal</h6>
                    <FormGroup>
                      <Label>
                        GSTIN No <span className="text-danger">*</span>
                      </Label>
                      <Field
                        name="gstnNo"
                        as={Input}
                        invalid={touched.gstnNo && !!errors.gstnNo}
                      />
                      <ErrorMessage
                        name="gstnNo"
                        component="div"
                        className="text-danger small"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>TAN No</Label>
                      <Field name="tanNo" as={Input} />
                    </FormGroup>
                    <FormGroup>
                      <Label>Service Tax No</Label>
                      <Field name="serviceTaxNo" as={Input} />
                    </FormGroup>

                    <FormGroup>
                      <Label>E.C.C No</Label>
                      <Field name="eccNo" as={Input} />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <h6 className="text-primary mb-2">Financial</h6>
                    <FormGroup>
                      <Label>Credit Days</Label>
                      <Field name="creditDays" as={Input} type="number" />
                    </FormGroup>
                    <FormGroup>
                      <Label>Credit Limit</Label>
                      <Field name="creditLimit" as={Input} type="number" />
                    </FormGroup>
                    <FormGroup>
                      <Label>Balance</Label>
                      <Field name="balance" as={Input} type="number" />
                    </FormGroup>
                    <h6 className="text-primary mt-3 mb-2">Tax Info</h6>
                    <FormGroup>
                      <Label>CST TIN No</Label>
                      <Field name="cstTinNo" as={Input} />
                    </FormGroup>
                    <FormGroup>
                      <Label>VAT TIN No</Label>
                      <Field name="vatTinNo" as={Input} />
                    </FormGroup>
                    <FormGroup>
                      <Label>PAN No</Label>
                      <Field name="panNo" as={Input} />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* === Address Section === */}
              <div className="mb-4">
                <FieldArray name="addressDtos">
                  {({ push, remove }) => (
                    <>
                      <div className="d-flex align-items-center mb-3">
                        <h5 className="text-success mb-0">
                          Shipping Address Details
                        </h5>
                        <Button
                          className="ms-2 btn-soft-primary"
                          color="primary"
                          size="sm"
                          type="button"
                          onClick={() => push({ address: "" })}
                        >
                          <Plus size={10} />
                        </Button>
                      </div>

                      {values.addressDtos.map((addr, index) => (
                        <Row key={index} className="align-items-end mb-2">
                          <Col md={4}>
                            <Label className="form-label">
                              Address {index + 1}
                            </Label>
                            <Field
                              name={`addressDtos.${index}.address`}
                              as={Input}
                              placeholder="Enter full address"
                            />
                          </Col>
                          <Col md={2}>
                            {values.addressDtos.length > 1 && (
                              <Button
                                color="danger"
                                size="sm"
                                type="button"
                                className="btn btn-soft-danger d-flex align-items-center justify-content-center"
                                onClick={() => remove(index)}
                              >
                                <X size={16} />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </>
                  )}
                </FieldArray>
              </div>

              {/* === Contact Person Section === */}
              <div className="mb-4">
                <FieldArray name="contactPersonDtos">
                  {({ push, remove }) => (
                    <>
                      <div className="d-flex align-items-center mb-3">
                        <h5 className="text-success mb-0">
                          Contact Person Details
                        </h5>
                        <Button
                          className="ms-2 btn-soft-primary"
                          color="primary"
                          size="sm"
                          type="button"
                          onClick={() =>
                            push({
                              name: "",
                              email: "",
                              mobileNo: "",
                            })
                          }
                        >
                          <Plus size={10} />
                        </Button>
                      </div>

                      {values.contactPersonDtos.map((person, index) => (
                        <Row key={index} className="align-items-end mb-2">
                          <Col md={3}>
                            <Field
                              name={`contactPersonDtos.${index}.name`}
                              as={Input}
                              placeholder="Name"
                            />
                          </Col>
                          <Col md={3}>
                            <Field
                              name={`contactPersonDtos.${index}.email`}
                              as={Input}
                              placeholder="Email"
                            />
                          </Col>
                          <Col md={3}>
                            <Field
                              name={`contactPersonDtos.${index}.mobileNo`}
                              as={Input}
                              placeholder="Mobile No"
                            />
                          </Col>
                          <Col md={2}>
                            {values.contactPersonDtos.length > 1 && (
                              <Button
                                color="danger"
                                size="sm"
                                type="button"
                                className="btn btn-soft-danger d-flex align-items-center justify-content-center"
                                onClick={() => remove(index)}
                              >
                                <X size={16} />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </>
                  )}
                </FieldArray>
              </div>

              {/* === Submit === */}
              <div className="text-end">
                <Button color="success" type="submit" className="btn-sm">
                  Update
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
};

export default EditCustomerForm;
